export const reviews = [
  {
    id: 1,
    name: 'Александр М.',
    avatar: 'https://public.readdy.ai/ai/img_res/6d32d19702b84ccc2420bf98770aaff6.jpg',
    rating: 5,
    text: 'Играю в Flagman уже полгода. Качество трансляции отличное, дилеры вежливые и профессиональные. Особенно нравится Lightning Roulette от Evolution - адреналин зашкаливает!',
    date: '15 декабря 2025',
    casino: 'Flagman'
  },
  {
    id: 2,
    name: 'Елена К.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20woman%20avatar%20portrait%20friendly%20smile%20dark%20background%20realistic%20photo%20style%20professional&width=160&height=160&seq=avatar-002&orientation=squarish',
    rating: 5,
    text: 'Martin - мой фаворит для игры в блэкджек. Русскоязычные дилеры, быстрые выплаты, никаких задержек в трансляции. Рекомендую всем!',
    date: '10 декабря 2025',
    casino: 'Martin'
  },
  {
    id: 3,
    name: 'Дмитрий П.',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20avatar%20portrait%20casual%20smile%20dark%20background%20realistic%20photo%20style%20modern&width=160&height=160&seq=avatar-003&orientation=squarish',
    rating: 4,
    text: 'В STARDA отличная подборка игр от Evolution. Crazy Time - просто огонь! Единственный минус - иногда бывают очереди на VIP столы в вечернее время.',
    date: '5 декабря 2025',
    casino: 'STARDA'
  },
  {
    id: 4,
    name: 'Ольга С.',
    avatar: 'https://readdy.ai/api/search-image?query=mature%20woman%20avatar%20portrait%20warm%20smile%20dark%20background%20realistic%20photo%20style%20elegant&width=160&height=160&seq=avatar-004&orientation=squarish',
    rating: 5,
    text: 'Fugu удивил качеством мобильной версии. Играю с планшета - всё работает идеально. Дилеры общительные, атмосфера как в настоящем казино.',
    date: '1 декабря 2025',
    casino: 'Fugu'
  },
  {
    id: 5,
    name: 'Игорь В.',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20man%20avatar%20portrait%20confident%20expression%20dark%20background%20realistic%20photo%20style%20business&width=160&height=160&seq=avatar-005&orientation=squarish',
    rating: 5,
    text: 'IRWIN - топ для хайроллеров. VIP столы с высокими лимитами, персональный менеджер всегда на связи. Выводы быстрые, без проблем.',
    date: '28 ноября 2025',
    casino: 'IRWIN'
  },
  {
    id: 6,
    name: 'Мария Л.',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20avatar%20portrait%20bright%20smile%20dark%20background%20realistic%20photo%20style%20cheerful&width=160&height=160&seq=avatar-006&orientation=squarish',
    rating: 4,
    text: 'LEX понравился разнообразием игр. Monopoly Live и Deal or No Deal - мои любимые. Бонусная программа щедрая, кэшбэк приходит вовремя.',
    date: '25 ноября 2025',
    casino: 'LEX'
  }
];